import _ from 'lodash';
import moment from 'moment';
import translate from '../../../core/tools/translate';
const reducers = {};

reducers.brands = (res, req) => {
    let brands;
    if (req.asArray) {
        brands = [];
        res.forEach(value => {
            let brand = value.Nome;
            if (brand.length >= 3) {
                brand = brand.toCapitalCase();
            }

            return brands.push(brand);
        });

        brands = brands.sort();
    } else {
        brands = res;
    }

    return brands;
};

reducers.config = (res) => {
    const _transformNameId = (data, startWith, shouldTranslate, propertyText = 'nome', propertyValue = 'id') =>
        _.transform(data, (r, c) => {
            const key = _.chain(c[propertyText]).deburr().camelCase().value();
            r[key] = {
                name: shouldTranslate ? translate(`Common.${c[propertyText]}`, { bandeira: res.client }) : c[propertyText],
                id: c[propertyValue]
            };

            if (shouldTranslate) {
                r[key].key = c[propertyText].charAt(0).toUpperCase() + c[propertyText].slice(1);
            }

            if (c.themes) {
                r[key].themes = _.map(c.themes, t => t[propertyValue]);
            }

            if (c.resolutionLevel) {
                r[key].resolutionLevel = c.resolutionLevel;
            }

            if (c.mascara) {
                r[key].mask = c.mascara;
            }

            if (c.neocomLocaleType) {
                r[key].neocomLocaleType = c.neocomLocaleType;
            }
            return r;
        }, startWith ? { automatic: { name: translate('Common.Automatic'), id: -1, themes: _.map(startWith, t => t[propertyValue]), key: 'Automatic' } } : {});

    if (_.size(res.areas)) {
        res.areas = _transformNameId(res.areas, res.areasDynamicThemes);
        if (res.areas.setor_censitario) {
            res.areas.setor_censitario = _.assign(res.areas.setor_censitario, { zoom: { min: 16, max: 18 } });
        }

        if (res.areas.bairro) {
            res.areas.bairro = _.assign(res.areas.bairro, { zoom: { min: 13, max: 15 } });
        }

        if (res.areas.subdistrito) {
            res.areas.subdistrito = _.assign(res.areas.subdistrito, { zoom: { min: 12, max: 12 } });
        }

        if (res.areas.municipio) {
            res.areas.municipio = _.assign(res.areas.municipio, { zoom: { min: 10, max: 11 } });
        }

        if (res.areas.uf) {
            res.areas.uf = _.assign(res.areas.uf, { zoom: { min: 7, max: 9 } });
        }

        if (res.areas.regiao) {
            res.areas.regiao = _.assign(res.areas.regiao, { zoom: { min: 4, max: 6 } });
        }

        if (res.areas.mao_livre) {
            delete res.areas.mao_livre;
        }
    }

    if (_.size(res.areasDynamicThemes)) {
        res.areasDynamicThemes = _transformNameId(res.areasDynamicThemes, null, true);
    }

    if (_.size(res.groupings)) {
        res.groupings = _transformNameId(res.groupings);
        if (res.groupings.dva) {
            res.groupings.dva = _.assign(res.groupings.dva, { zoom: { min: 10, max: 13 } });
        }

        if (res.groupings.mva) {
            res.groupings.mva = _.assign(res.groupings.mva, { zoom: { min: 8, max: 9 } });
        }

        if (res.groupings.area_demarcada) {
            res.groupings.area_demarcada = _.assign(res.groupings.area_demarcada, { zoom: { min: 7, max: 13 } });
        }
    }

    if (_.size(res.groupingDynamicThemes)) {
        res.groupingDynamicThemes = _transformNameId(res.groupingDynamicThemes, null, true);
    }

    if (_.size(res.voronois)) {
        res.voronois = _transformNameId(res.voronois);
    }

    if (_.size(res.voronoiThemes)) {
        res.voronoiThemes = _transformNameId(res.voronoiThemes, null, true);
    }

    if (_.size(res.dncFlexibleAreas)) {
        res.dncFlexibleAreas = _transformNameId(res.dncFlexibleAreas);
        _.forEach(_.assign({}, res.areas, res.groupings), (val, key) => {
            if (res.dncFlexibleAreas[key] && res.dncFlexibleAreas[key].id === val.id && val.zoom) {
                res.dncFlexibleAreas[key].zoom = val.zoom;
            }
        });
    }

    if (_.size(res.ucdDirectSale)) {
        res.ucdDirectSale = _transformNameId(res.ucdDirectSale, res.ucdThemes);

        if (res.ucdDirectSale.uf) {
            res.ucdDirectSale.uf = _.assign(res.ucdDirectSale.uf, { zoom: { min: 2, max: 8 } });
        }
        if (res.ucdDirectSale.municipio) {
            res.ucdDirectSale.municipio = _.assign(res.ucdDirectSale.municipio, { zoom: { min: 9, max: 20 } });
        }
    }


    if (_.size(res.ucdThemes)) {
        res.ucdThemes = _transformNameId(res.ucdThemes, null, true);
    }

    if (_.size(res.economicGroups)) {
        res.economicGroups = _.map(res.economicGroups, (val) => ({
            text: val.text,
            value: val.value
        }));
    }

    if (_.size(res.salesChannel)) {
        res.salesChannel = _.map(res.salesChannel, (val) => ({
            text: val.name,
            value: val.idSaleChannelAggregate
        }));
    }

    if(_.size(res.saleTypes)) {
        res.saleTypes =
        _.map(_transformNameId(res.saleTypes, null, true, 'text', 'value'), (val) => ({
            text: val.name,
            value: val.id
        }));
    }

    res.notifications = res.notifications || {};

    res.clientSegments = _transformNameId(res.clientSegments);

    if (_.size(res.contextDateFilters)) {
        res.contextDateFilters = _.reduce(res.contextDateFilters, (r, v) => {
            r[_.upperCase(v.Contexto)] = {
                START: moment(v.DataInicio).toDate(),
                END: moment(v.DataFim).toDate()
            };

            return r;
        }, {});
    }

    return res;
};

export default reducers;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/general/reducers.js